module.exports = __webpack_public_path__ + "static/media/beausite-classic-clear.24e4c3ee.woff2";